import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, type MenuProps, Typography } from 'antd'
import { useGetIdentity, useLogout } from '@refinedev/core'
import { useNavigate } from 'react-router-dom'

const { Text } = Typography

/**
 * 顶栏用户菜单
 * 显示管理员头像 + 用户名，下拉菜单含设置、登出
 */
export function UserMenu() {
  const { data: identity } = useGetIdentity<{ id: string; username: string; role: string }>()
  const { mutate: logout } = useLogout()
  const navigate = useNavigate()

  const items: MenuProps['items'] = [
    {
      key: 'profile',
      label: (
        <div style={{ padding: '4px 0', minWidth: 160 }}>
          <div style={{ fontWeight: 500 }}>{identity?.username ?? 'admin'}</div>
          <div style={{ fontSize: 12, color: 'var(--ant-color-text-tertiary)', marginTop: 2 }}>
            {identity?.role === 'super' ? '超级管理员' : identity?.role ?? '管理员'}
          </div>
        </div>
      ),
      disabled: true
    },
    { type: 'divider' },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '设置',
      onClick: () => navigate('/settings')
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => logout()
    }
  ]

  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <div
        className="app-user-menu"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 10px',
          borderRadius: 6,
          cursor: 'pointer',
          transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'var(--app-nav-hover-bg)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent'
        }}
      >
        <Avatar
          size={28}
          icon={<UserOutlined />}
          style={{ backgroundColor: 'var(--ant-color-primary)' }}
        />
        <Text style={{ fontSize: 13, fontWeight: 500 }}>
          {identity?.username ?? 'admin'}
        </Text>
      </div>
    </Dropdown>
  )
}
